export default "__VITE_ASSET__CnXLtUp$__"